import { ApplicationState } from "../../app/store";

export const selectPartner = (store: ApplicationState) => store.partner;
